
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Shield, Calendar, User } from 'lucide-react';
import { Admin } from '@/types/admin.types';
import { format } from 'date-fns';

interface AdminProfileCardProps {
  admin: Admin;
}

const AdminProfileCard = ({ admin }: AdminProfileCardProps) => {
  const getInitials = () => {
    return `${admin.firstName.charAt(0)}${admin.lastName.charAt(0)}`;
  };

  return (
    <Card className="card-glow">
      <CardHeader className="text-center pb-2">
        <div className="flex justify-center mb-4">
          <Avatar className="h-24 w-24">
            <AvatarImage 
              src={admin.profileImage} 
              alt={`${admin.firstName} ${admin.lastName}`}
              onError={(e) => {
                console.log("Profile image load error in details view, using fallback");
                e.currentTarget.src = '/placeholder.svg';
              }}
            />
            <AvatarFallback className="text-2xl">{getInitials()}</AvatarFallback>
          </Avatar>
        </div>
        <CardTitle className="text-2xl">{admin.firstName} {admin.lastName}</CardTitle>
        <CardDescription className="text-lg">{admin.position}</CardDescription>
      </CardHeader>
      <CardContent className="pt-2">
        <div className="flex justify-center mb-4">
          <Badge variant={admin.status === 'Active' ? 'default' : 'secondary'} className="px-3 py-1 text-sm">
            {admin.status}
          </Badge>
        </div>
        <div className="space-y-2">
          <div className="flex items-center text-sm">
            <Shield className="h-4 w-4 mr-2 text-muted-foreground" />
            <span className="text-muted-foreground mr-2">Role:</span>
            <span className="font-medium">{admin.role}</span>
          </div>
          <div className="flex items-center text-sm">
            <Calendar className="h-4 w-4 mr-2 text-muted-foreground" />
            <span className="text-muted-foreground mr-2">Joined:</span>
            <span className="font-medium">
              {admin.joinDate ? format(new Date(admin.joinDate), 'MMMM dd, yyyy') : 'N/A'}
            </span>
          </div>
          <div className="flex items-center text-sm">
            <User className="h-4 w-4 mr-2 text-muted-foreground" />
            <span className="text-muted-foreground mr-2">ID:</span>
            <span className="font-medium">{admin.id}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminProfileCard;
